import React from "react";
import { connect } from "react-redux";

import { checkAccess, ids } from "../../../../helpers/rolAccess";
import { loadTabs } from "../../../Header/actions";
import TableInboxSolicitudes from "./tableInboxSolicitudes";
import NewTableInboxSolicitudes from "./newTableInboxSolicitudes";

class InboxSolicitudes extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOld: true,
    };
  }
  componentDidUpdate = (prevProps) => {
    if ((prevProps.userAccessIds === null && Array.isArray(this.props.userAccessIds))
      || this.props.currentHeader !== "Inbox solicitudes SEL ") {
      this.loadTabs();
    }
  }

  loadTabs = () => {
    const tabs = [];
    if (checkAccess(ids.inboxSolicitudes, this.props.userAccessIds)) tabs.push({ text: "Solicitudes", contentId: 0 });
    this.props.dispatch(loadTabs("Inbox solicitudes SEL ", "", tabs, tabs.length ? tabs[0].contentId : null));
  }
  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0: {
        return this.state.isOld ? <TableInboxSolicitudes /> : <NewTableInboxSolicitudes />;
      }

      default:
        return <div />;
    }
  }
  render() {
    return (
      <div>
        {this.renderBody()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(InboxSolicitudes);
